export const navigateTo = (url: string) => {
  window.location.assign(url);
};
